import { ref } from 'vue';

import { useLogout } from '@composables/use-session-actions';
import { resetTenantSpecificStores } from '@/stores';
import { useShareStore } from '@stores/share-store';
import { useTenantShareStore } from '@stores/tenant-share-store';
import { useTenantStore } from '@stores/tenant-store';
import { useTenantParamStore } from '@stores/tenant-param-store';
import { useTenantUserStore } from '@stores/tenant-user-store';
import { useUserStore } from '@stores/user-store';
import {
  apiFetchCurrentTenantUser,
  apiFetchCurrentUser,
  apiFetchShares,
  apiFetchTenant,
  apiFetchTenantParams,
  apiFetchTenantShares,
} from '@api/v1/requests';

export const useInitialize = () => {
  const { softLogout } = useLogout();
  const userStore = useUserStore();
  const shareStore = useShareStore();
  const tenantShareStore = useTenantShareStore();
  const tenantStore = useTenantStore();
  const tenantUserStore = useTenantUserStore();
  const tenantParamStore = useTenantParamStore();

  const initializedUserApp = ref(false);
  const initializedTenantApp = ref(false);

  const initializeUserApp = async () => {
    initializedUserApp.value = false;

    {
      const res = await apiFetchCurrentUser({
        errorConfig: {
          disableConsole: true,
          feedbackMessage: 'Failed to fetch user.',
          propagateError: true,
        },
        callbacks: {
          onError: async () => {
            await softLogout();
          },
        },
      });
      await userStore.set(res.data);
    }

    {
      const res = await apiFetchShares({
        errorConfig: {
          disableConsole: true,
          feedbackMessage: 'Failed to fetch system params.',
          propagateError: true,
        },
        callbacks: {
          onError: () => {
            resetTenantSpecificStores();
          },
        },
      });
      await shareStore.set(res.data);
    }

    initializedUserApp.value = await true;
  };

  const initializeTenantApp = async () => {
    initializedTenantApp.value = false;

    {
      const res = await apiFetchTenant({
        errorConfig: {
          disableConsole: true,
          feedbackMessage: 'Failed to fetch current workspace.',
          propagateError: true,
        },
      });
      await tenantStore.set(res.data);
    }

    {
      const res = await apiFetchTenantShares({
        errorConfig: {
          disableConsole: true,
          feedbackMessage: 'Failed to fetch tenant app global variables.',
          propagateError: true,
        },
      });
      await tenantShareStore.set(res.data);
    }

    {
      const res = await apiFetchTenantParams({
        errorConfig: {
          disableConsole: true,
          feedbackMessage: 'Failed to fetch workspace params.',
          propagateError: true,
        },
      });
      await tenantParamStore.set(res.data);
    }

    {
      const res = await apiFetchCurrentTenantUser({
        errorConfig: {
          disableConsole: true,
          feedbackMessage: 'Failed to fetch workspace user data.',
          propagateError: true,
        },
      });
      await tenantUserStore.set(res.data);
    }

    initializedTenantApp.value = await true;
  };

  return {
    initializeUserApp,
    initializeTenantApp,
    initializedUserApp,
    initializedTenantApp,
  };
};
